/**
 * This is the entry point for all API requests.
 * import API modules and expose them to components via Vue.prototype.$api
 */
import news from "./modules/news";
import schools from "./modules/schools";
import essentials from "./modules/essentials";
import newsletters from "./modules/newsletters";
import events from "./modules/events";
import user from "./modules/user";
import notifications from "./modules/notifications";

export default {
  news,
  schools,
  essentials,
  newsletters,
  events,
  user,
  notifications,
};
